import React from "react";

const Dots = () => {
      return(
            <div className="radix-iconsdot-filled-parent">
                  <div className="radix-iconsdot-filled">
                        <img className="vector-icon10" alt="" src="/vector3.svg" />
                  </div>
                  <div className="radix-iconsdot-filled">
                        <img className="vector-icon10" alt="" src="/vector4.svg" />
                  </div>
                  <div className="radix-iconsdot-filled">
                        <img className="vector-icon10" alt="" src="/vector4.svg" />
                  </div>
                  <div className="radix-iconsdot-filled">
                        <img className="vector-icon10" alt="" src="/vector4.svg" />
                  </div>
                  <div className="radix-iconsdot-filled">
                        <img className="vector-icon10" alt="" src="/vector4.svg" />
                  </div>
            </div>
      );
};

export default Dots;